export default __webpack_public_path__ + "e36f870b31a0afc1518d4f71ca00ac98.png";